import { palette } from "../../styles/palette";

export const styles = {
  onBoarding: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: palette.neutralBCGGrey,
  },
};
